import { useSelector } from 'react-redux';

export const useActiveProcess = () => {
  return useSelector(state => state.process.selectedProcess);
};

export default useActiveProcess;